import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes = process.env.VUE_APP_SITE !== 'area_limit'
  ? [
    {
      path: '/',
      redirect: '/maintenance'
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/views/LotteryMaintenance')
    },
    {
      path: '/arealimit',
      name: 'arealimit',
      component: () => import('@/views/AreaLimit')
    }
  ]
  : [{
    path: '/',
    name: 'arealimit',
    component: () => import('@/views/AreaLimit')
  }]
const creatRouter = () => {
  return new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
  })
}

const router = creatRouter()

export default router
